module.exports = __webpack_public_path__ + "img/dc_06.0a731de0.jpg";